/**
 * API client — Axios com auto-attach do JWT do Supabase + redirect em 401.
 */
import axios from "axios";
import { getSupabase } from "./supabase";

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE,
});

// Rotas onde 401 não deve causar redirect (evita loop)
const PUBLIC_PATHS = new Set(["/", "/login", "/signup", "/auth/callback"]);

// Injetar JWT do Supabase em toda request
api.interceptors.request.use(async (config) => {
  if (typeof window === "undefined") return config;

  const supabase = getSupabase();
  const { data: { session } } = await supabase.auth.getSession();

  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
});

// Em 401: faz logout e redireciona pro login (a menos que esteja em rota pública)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      typeof window !== "undefined" &&
      error?.response?.status === 401 &&
      !PUBLIC_PATHS.has(window.location.pathname)
    ) {
      const supabase = getSupabase();
      await supabase.auth.signOut();
      window.location.replace("/login");
    }
    return Promise.reject(error);
  },
);
